"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CanvasObjectEvents = exports.AbstractCanvasObject = void 0;
var _Observable = require("../Observable");
var _Calc2D = require("../../Utils/Calc2D");
var _v = _interopRequireDefault(require("uuid/v4"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == _typeof(h) && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw new Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator["return"] && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(_typeof(e) + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw new Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, "catch": function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var CanvasObjectEvents = exports.CanvasObjectEvents = /*#__PURE__*/function (CanvasObjectEvents) {
  CanvasObjectEvents["OnChange"] = "onChange";
  return CanvasObjectEvents;
}({});
var AbstractCanvasObject = exports.AbstractCanvasObject = /*#__PURE__*/function () {
  function AbstractCanvasObject(options) {
    _classCallCheck(this, AbstractCanvasObject);
    // base properties
    _defineProperty(this, "_x", 0);
    _defineProperty(this, "_y", 0);
    _defineProperty(this, "_rotation", 0);
    _defineProperty(this, "_scaling", 1);
    _defineProperty(this, "_uuid", (0, _v["default"])());
    /**
     * use only to set different scaling for the adapter in setScaling()
     * can be useful if we have to work with a smaller preview image which should be shown in its real size,
     * keeping the original scaling value
     * Notes:
     *  - this value should not be saved with the object data, it has to be provided explicitly
     *  - this value has no relation to any other attribute (eg. Image.src or Image.imageData)
     *  - the responsibility of updating always belongs to the consumer of this package
     */
    _defineProperty(this, "_scaleFactor", 1);
    // important: do not modify width and height directly,
    // they should only have getters if needed, all the others should be done by scaling
    // technical properties
    _defineProperty(this, "_wrappedObject", null);
    _defineProperty(this, "_selected", false);
    _defineProperty(this, "_locked", false);
    _defineProperty(this, "_autoFit", false);
    _defineProperty(this, "_grabbed", false);
    _defineProperty(this, "_activeAction", '');
    _defineProperty(this, "_userData", {});
    _defineProperty(this, "_canvas", null);
    _defineProperty(this, "_observable", new _Observable.Observable(this));
    this.initOptions(options);
    this._observable.on(CanvasObjectEvents.OnChange, this.updateConstraints.bind(this));
  }
  _createClass(AbstractCanvasObject, [{
    key: "initOptions",
    value: function initOptions(options) {
      if (options) {
        for (var _i = 0, _Object$keys = Object.keys(options); _i < _Object$keys.length; _i++) {
          var key = _Object$keys[_i];
          this["_".concat(key)] = options[key];
        }
      }
      return this;
    }
  }, {
    key: "updateOptions",
    value: function () {
      var _updateOptions = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(options) {
        var _i2, _Object$keys2, key;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (options) {
                for (_i2 = 0, _Object$keys2 = Object.keys(options); _i2 < _Object$keys2.length; _i2++) {
                  key = _Object$keys2[_i2];
                  if (Object.prototype.hasOwnProperty.call(this, '_' + key) && key !== 'uuid') {
                    this[key] = options[key];
                  }
                }
              }
              return _context.abrupt("return", this);
            case 2:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function updateOptions(_x) {
        return _updateOptions.apply(this, arguments);
      }
      return updateOptions;
    }()
  }, {
    key: "uuid",
    get: function get() {
      return this._uuid;
    }
  }, {
    key: "type",
    get: function get() {
      if (this.constructor.type) {
        return this.constructor.type;
      }
      throw new TypeError('Type is not defined for this canvas object!');
    }
  }, {
    key: "x",
    get: function get() {
      return this._x;
    },
    set: function set(x) {
      if (x === this._x) {
        return;
      }
      this._x = x;
      this.setPosition(this._x, this._y);
      this._observable.triggerEvent(CanvasObjectEvents.OnChange);
    }
  }, {
    key: "y",
    get: function get() {
      return this._y;
    },
    set: function set(y) {
      if (y === this._y) {
        return;
      }
      this._y = y;
      this.setPosition(this._x, this._y);
      this._observable.triggerEvent(CanvasObjectEvents.OnChange);
    }
  }, {
    key: "rotation",
    get: function get() {
      return this._rotation;
    },
    set: function set(rotation) {
      var rot = (360 + rotation) % 360;
      if (rot === this._rotation) {
        return;
      }
      this._rotation = rot;
      this.setRotation(this._rotation);
      this._observable.triggerEvent(CanvasObjectEvents.OnChange);
    }
  }, {
    key: "scaling",
    get: function get() {
      return this._scaling;
    },
    set: function set(scaling) {
      if (scaling === this._scaling || !Number.isFinite(scaling)) {
        return;
      }
      this._scaling = scaling;
      this.setScalingWithFactor(scaling);
      this._observable.triggerEvent(CanvasObjectEvents.OnChange);
    }
  }, {
    key: "wrappedObject",
    get: function get() {
      return this._wrappedObject;
    },
    set: function set(object) {
      this._wrappedObject = object;
      this.setOptionsFromObject(this.toObject());
      this.initObjectEvents();
    }
  }, {
    key: "selected",
    get: function get() {
      return this._selected;
    },
    set: function set(selected) {
      this._selected = selected;
      if (selected) {
        this.canvas.setSelectedObject(this);
      } else {
        this.canvas.deselectObject(this);
      }
      this.setSelected(selected);
      this._observable.triggerEvent(CanvasObjectEvents.OnChange);
    }
  }, {
    key: "locked",
    get: function get() {
      return this._locked;
    },
    set: function set(locked) {
      this._locked = locked;
      this._observable.triggerEvent(CanvasObjectEvents.OnChange);
    }
  }, {
    key: "autoFit",
    get: function get() {
      return this._autoFit;
    },
    set: function set(autoFit) {
      this._autoFit = autoFit;
      this._observable.triggerEvent(CanvasObjectEvents.OnChange);
    }
  }, {
    key: "userData",
    get: function get() {
      return this._userData;
    },
    set: function set(userDataObject) {
      this._userData = userDataObject;
      this._observable.triggerEvent(CanvasObjectEvents.OnChange);
    }
  }, {
    key: "grabbed",
    get: function get() {
      return this._grabbed;
    },
    set: function set(grabbed) {
      this._grabbed = grabbed;
      this._observable.triggerEvent(CanvasObjectEvents.OnChange);
    }
  }, {
    key: "activeAction",
    get: function get() {
      return this._activeAction;
    },
    set: function set(action) {
      this._activeAction = action;
      this._observable.triggerEvent(CanvasObjectEvents.OnChange);
    }
  }, {
    key: "canvas",
    get: function get() {
      return this._canvas;
    },
    set: function set(canvas) {
      this._canvas = canvas;
    }
  }, {
    key: "isFirst",
    get: function get() {
      return this.getIndex() === 0;
    }
  }, {
    key: "isLast",
    get: function get() {
      return this.getIndex() === this.canvas.getLength() - 1;
    }

    /**
     * Calls the setScaling method with the given scaling multiplied by the scaleFactor
     * @param scaling
     */
  }, {
    key: "setScalingWithFactor",
    value: function setScalingWithFactor(scaling) {
      this.setScaling(scaling * this._scaleFactor);
    }
  }, {
    key: "on",
    value: function on(eventName, callback) {
      this._observable.on(eventName, callback);
    }
  }, {
    key: "off",
    value: function off(eventName, callback) {
      this._observable.off(eventName, callback);
    }
  }, {
    key: "getState",
    value: function getState() {
      var selected = this.selected,
        grabbed = this.grabbed,
        isFirst = this.isFirst,
        isLast = this.isLast,
        locked = this.locked,
        autoFit = this.autoFit;
      return _objectSpread(_objectSpread({}, this.toObject()), {}, {
        selected: selected,
        grabbed: grabbed,
        isFirst: isFirst,
        isLast: isLast,
        locked: locked,
        autoFit: autoFit
      });
    }
  }, {
    key: "getDistanceToCenter",
    value: function getDistanceToCenter(x, y) {
      var center = this.getCenter();
      return (0, _Calc2D.distanceFromOrigin)(x, y, center.x, center.y);
    }
  }, {
    key: "remove",
    value: function remove() {
      this.canvas.remove(this);
      this._observable.triggerEvent(CanvasObjectEvents.OnChange);
    }
  }, {
    key: "getIndex",
    value: function getIndex() {
      return this.canvas.indexOfObject(this);
    }
  }, {
    key: "setIndex",
    value: function setIndex(newIdx) {
      var overwrite = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      this.canvas.setObjectIndex(this, newIdx, overwrite);
      this._observable.triggerEvent(CanvasObjectEvents.OnChange);
    }
  }, {
    key: "toObject",
    value: function toObject() {
      var includeWrappedObject = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var type = this.type,
        x = this.x,
        y = this.y,
        rotation = this.rotation,
        scaling = this.scaling,
        locked = this.locked,
        autoFit = this.autoFit,
        userData = this.userData,
        uuid = this.uuid;
      var obj = {
        type: type,
        x: x,
        y: y,
        rotation: rotation,
        scaling: scaling,
        locked: locked,
        autoFit: autoFit,
        userData: userData,
        uuid: uuid
      };
      if (includeWrappedObject) {
        obj.__wrappedObject = this.wrappedObjectToObject();
      }
      return obj;
    }
  }, {
    key: "setOptionsFromObject",
    value: function setOptionsFromObject(obj) {
      var x = obj.x,
        y = obj.y,
        rotation = obj.rotation,
        scaling = obj.scaling;
      this.setPosition(x, y);
      this.setRotation(rotation);
      this.setScalingWithFactor(scaling);
    }
  }, {
    key: "alignTo",
    value: function alignTo(vertical, horizontal) {
      var x = this.x,
        y = this.y;
      var _this$getBoundSize = this.getBoundSize(),
        height = _this$getBoundSize.height,
        width = _this$getBoundSize.width;
      switch (vertical) {
        case 'top':
          y = height / 2;
          break;
        case 'bottom':
          y = this.canvas.getSize().height - height / 2;
          break;
        case 'center':
          y = this.canvas.getSize().height / 2;
          break;
      }
      switch (horizontal) {
        case 'left':
          x = width / 2;
          break;
        case 'right':
          x = this.canvas.getSize().width - width / 2;
          break;
        case 'center':
          x = this.canvas.getSize().width / 2;
          break;
      }
      this.x = x;
      this.y = y;
    }
  }, {
    key: "fitCanvas",
    value: function fitCanvas() {
      var enlarge = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      var updatePosition = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      var _this$canvas$getSize = this.canvas.getSize(),
        cw = _this$canvas$getSize.width,
        ch = _this$canvas$getSize.height;
      var _this$getBoundSize2 = this.getBoundSize(),
        ow = _this$getBoundSize2.width,
        oh = _this$getBoundSize2.height;
      var maxRatio = Math.max(ow / cw, oh / ch);
      if (maxRatio > 1 || maxRatio < 1 && enlarge) {
        this.scaling *= 1 / maxRatio;
      }
      if (updatePosition) {
        this.x = cw / 2;
        this.y = ch / 2;
      }
    }
  }, {
    key: "getScaledSize",
    value: function getScaledSize() {
      var _this$getSize = this.getSize(),
        ow = _this$getSize.width,
        oh = _this$getSize.height;
      var scaling = this.scaling,
        _scaleFactor = this._scaleFactor;
      return {
        width: ow * scaling * _scaleFactor,
        height: oh * scaling * _scaleFactor
      };
    }
  }, {
    key: "updateConstraints",
    value: function updateConstraints() {
      this.autoFit && this.fitCanvas(true, true);
    }
  }]);
  return AbstractCanvasObject;
}();
// this should be provided by every canvas object adapter
_defineProperty(AbstractCanvasObject, "type", void 0);